var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "feiGe" } },
    [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "flex-direction": "row",
            "align-items": "center",
            "margin-bottom": "10px",
            cursor: "pointer",
            width: "100px"
          },
          on: { click: _vm.goBack }
        },
        [
          _c("i", { staticClass: "el-icon-arrow-left" }),
          _vm._v(" "),
          _c("div", { staticStyle: { "margin-left": "10px" } }, [
            _vm._v("返回")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "el-tabs",
        {
          attrs: { "tab-position": "left" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.tabCurrent,
            callback: function($$v) {
              _vm.tabCurrent = $$v
            },
            expression: "tabCurrent"
          }
        },
        [
          _c("el-tab-pane", { attrs: { name: "zero" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("通关必看")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "startvideo", attrs: { id: "startvideo" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startVideo }
                      },
                      [_vm._v("开始学习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-zero" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "zero",
                      src:
                        "http://taojinyun.file.itaojin.cn/qianniusource/202412/%E9%80%9A%E5%85%B3%E5%BF%85%E7%9C%8B.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        您的浏览器不支持 video 标签。\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-zero" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-first")
                          }
                        }
                      },
                      [_vm._v("继续下一步学习")]
                    )
                  ])
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "first" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("1、登录飞鸽工作台")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-first" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "first",
                      src:
                        "http://res.study.itaojin.cn/2023-02/385cc51762b74eb985d3ab9b39f0925a.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        您的浏览器不支持 video 标签。\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-first" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon,
                          expression: "isShowQnIcon"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../../static/feige/fgbg1-1.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "qnicon01",
                        on: { mouseenter: _vm.showLoginImg }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon2,
                          expression: "isShowQnIcon2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../../static/feige/fgbg1-2.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "qnicon01",
                        attrs: { id: "select" },
                        on: { dblclick: _vm.showLoginImg2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isShowIcon3
                    ? _c("div", { staticClass: "qnbox" }, [
                        _c("img", {
                          staticClass: "qnbg left-img",
                          attrs: {
                            src: require("../../../../static/feige/fgbg1-3.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "fgicon03",
                          on: { click: _vm.showLoginImg3 }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon4,
                          expression: "isShowIcon4"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: require("../../../../static/feige/fgbg1-4.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon04",
                        on: { mouseenter: _vm.showLoginImg4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon5,
                          expression: "isShowIcon5"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: require("../../../../static/feige/fgbg1-5.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon05",
                        on: { click: _vm.showLoginImg5 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon6,
                          expression: "isShowIcon6"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: require("../../../../static/feige/fgbg1-6.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon06",
                        on: { click: _vm.showLoginImg6 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon7,
                          expression: "isShowIcon7"
                        }
                      ],
                      staticClass: "qnbox login"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: require("../../../../static/feige/fgbg1-7.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.name,
                            expression: "name",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "name",
                        attrs: { type: "text" },
                        domProps: { value: _vm.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.name = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon07",
                        on: { click: _vm.showLoginImg7 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowIcon8,
                          expression: "isShowIcon8"
                        }
                      ],
                      staticClass: "qnbox login"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg left-img",
                        attrs: {
                          src: require("../../../../static/feige/fgbg1-8.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.name,
                            expression: "name",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "name",
                        attrs: { type: "text" },
                        domProps: { value: _vm.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.name = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.password,
                            expression: "password",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "password",
                        attrs: {
                          type: "password",
                          autocomplete: "new-password"
                        },
                        domProps: { value: _vm.password },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.password = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon08",
                        on: { click: _vm.loginIn }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLogin1,
                          expression: "isShowLogin1"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../../static/feige/fgbg1-9.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon09",
                        on: { mouseenter: _vm.loginIn1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLogin2,
                          expression: "isShowLogin2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../../static/feige/fgbg1-10.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon09",
                        on: { click: _vm.loginIn2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLogin3,
                          expression: "isShowLogin3"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../../static/feige/fgbg1-11.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon09",
                        on: {
                          contextmenu: function($event) {
                            $event.preventDefault()
                            return _vm.loginIn3.apply(null, arguments)
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLogin4,
                          expression: "isShowLogin4"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../../static/feige/fgbg1-12.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fgicon10",
                        on: { click: _vm.loginIn4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowLogin5,
                          expression: "isShowLogin5"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../../static/feige/fgbg1-13.png")
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _c("h3", [
                      _c("span", { staticClass: "line" }),
                      _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                    ]),
                    _vm._v(" "),
                    _vm.isShowQnIcon || _vm.isShowQnIcon2
                      ? _c("p", [
                          _vm._v("请打开"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("左侧练习场")
                          ]),
                          _vm._v("中的飞鸽客服工作台")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowIcon3
                      ? [
                          _c("p", [
                            _vm._v("选择"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("我是商家")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowIcon4 || _vm.isShowIcon5
                      ? [
                          _c("p", [
                            _vm._v("点击右上角的电脑图标，切换为"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("手机号登录")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowIcon6 || _vm.isShowIcon7 || _vm.isShowIcon8
                      ? [
                          _c("p", [
                            _vm._v("注意："),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("正式任务")
                            ]),
                            _vm._v("需提前将"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("自己的手机号")
                            ]),
                            _vm._v("反馈给主管开通账号！")
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("假设练习场"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("账号为：13853678478")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("验证码为：3346")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLogin1 || _vm.isShowLogin2
                      ? [
                          _c("p", [
                            _vm._v("鼠标"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("左键")
                            ]),
                            _vm._v("点击"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("第2个")
                            ]),
                            _vm._v("店铺，切换到第2个店铺")
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLogin3 || _vm.isShowLogin4
                      ? [
                          _c("p", [
                            _vm._v("鼠标"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("右键")
                            ]),
                            _vm._v("点击"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("第2个")
                            ]),
                            _vm._v("店铺，"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("退出店铺")
                            ]),
                            _vm._v("铺")
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyFirst }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-second")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: require("../../../../static/newqianniu/ppt.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("登录飞鸽.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "second" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("2、基础设置（上）")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-second" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "second",
                      src:
                        "http://res.study.itaojin.cn/2023-02/ffe43489dcdf458cb1df730725770806.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        您的浏览器不支持 video 标签。\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-second" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp,
                          expression: "isShowSetUp"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/2/fgbg2-1.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon01",
                        on: { click: _vm.setUp }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp1,
                          expression: "isShowSetUp1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/2/fgbg2-2.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon02",
                        on: { mouseenter: _vm.setUp1 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp2,
                          expression: "isShowSetUp2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/2/fgbg2-3.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon02",
                        on: { click: _vm.setUp2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp3,
                          expression: "isShowSetUp3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/2/fgbg2-4.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon03",
                        on: { click: _vm.setUp3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp4,
                          expression: "isShowSetUp4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/2/fgbg2-5.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon04",
                        on: { mouseenter: _vm.setUp4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp5,
                          expression: "isShowSetUp5"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/2/fgbg2-6.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon04",
                        on: { click: _vm.setUp5 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp6,
                          expression: "isShowSetUp6"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/2/fgbg2-7.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon05",
                        on: { mouseenter: _vm.setUp6 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp7,
                          expression: "isShowSetUp7"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/2/fgbg2-8.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon05",
                        on: { click: _vm.setUp7 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp8,
                          expression: "isShowSetUp8"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/2/fgbg2-9.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon06",
                        on: { mouseenter: _vm.setUp8 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp9,
                          expression: "isShowSetUp9"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/2/fgbg2-10.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seticon06",
                        on: { click: _vm.setUp9 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetUp10,
                          expression: "isShowSetUp10"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/2/fgbg2-11.png")
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v(
                      "\n                            提示\n                        "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.isShowSetUp || _vm.isShowSetUp1 || _vm.isShowSetUp2
                    ? _c("p", [
                        _vm._v("请将状态切换为"),
                        _c("span", { staticClass: "blod-span" }, [
                          _vm._v("在线")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowSetUp3 || _vm.isShowSetUp4 || _vm.isShowSetUp5
                    ? _c("p", [
                        _vm._v("请将状态切换为"),
                        _c("span", { staticClass: "blod-span" }, [
                          _vm._v("小休")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowSetUp6 ||
                  _vm.isShowSetUp7 ||
                  _vm.isShowSetUp8 ||
                  _vm.isShowSetUp9
                    ? _c("p", [
                        _vm._v("请将当前会话的接待排序设置为：按"),
                        _c("span", { staticClass: "blod-span" }, [
                          _vm._v("等待时长")
                        ]),
                        _vm._v("由长到短排序")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudySecond }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-third")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v(
                    "\n                        查看学习资料\n                    "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: require("../../../../static/newqianniu/ppt.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("基础设置（上）.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt1
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt1(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt1 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer1" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "third" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("2、基础设置（下）")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-third" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "third",
                      src:
                        "http://res.study.itaojin.cn/2023-02/9154da85cd3b4f718d49e1502dd0d96e.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        您的浏览器不支持 video 标签。\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-third" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown,
                          expression: "isShowSetDown"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/2/fgbg2-11.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown1,
                          expression: "isShowSetDown1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/1-01.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown",
                        on: {
                          click: function($event) {
                            return _vm.setDown1()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown2,
                          expression: "isShowSetDown2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/1-02.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown01",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown2()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown3,
                          expression: "isShowSetDown3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/1-03.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown01",
                        on: {
                          click: function($event) {
                            return _vm.setDown3()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown4,
                          expression: "isShowSetDown4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/1-04.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown02",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown4()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown5,
                          expression: "isShowSetDown5"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/1-05.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown02",
                        on: {
                          click: function($event) {
                            return _vm.setDown5()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown6,
                          expression: "isShowSetDown6"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/1-06.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown03",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown6()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown7,
                          expression: "isShowSetDown7"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/1-07.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown03",
                        on: {
                          click: function($event) {
                            return _vm.setDown7()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown033",
                        on: {
                          click: function($event) {
                            return _vm.setDown7()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown8,
                          expression: "isShowSetDown8"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/1-08.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown04",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown8()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown9,
                          expression: "isShowSetDown9"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/1-09.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown04",
                        on: {
                          click: function($event) {
                            return _vm.setDown9()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown10,
                          expression: "isShowSetDown10"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/1-10.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown05",
                        on: {
                          click: function($event) {
                            return _vm.setDown10()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown11,
                          expression: "isShowSetDown11"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/1-11.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.dyInput,
                            expression: "dyInput",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "dyInput",
                        attrs: { type: "text" },
                        domProps: { value: _vm.dyInput },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.dyInput = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown06",
                        on: {
                          click: function($event) {
                            return _vm.setDown11()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown12,
                          expression: "isShowSetDown12"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/1-12.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown07",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown12()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown13,
                          expression: "isShowSetDown13"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/1-13.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown07",
                        on: {
                          click: function($event) {
                            return _vm.setDown13()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown14,
                          expression: "isShowSetDown14"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/1-14.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "dynr",
                        on: {
                          click: function($event) {
                            return _vm.setDown14()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "bmdy",
                        on: {
                          click: function($event) {
                            return _vm.setDown15()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown15,
                          expression: "isShowSetDown15"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/1-15.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.dynr,
                            expression: "dynr",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "dynr",
                        domProps: { value: _vm.dynr },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.dynr = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "bmdy",
                        on: {
                          click: function($event) {
                            return _vm.setDown16()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown16,
                          expression: "isShowSetDown16"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/1-16.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.dynr,
                            expression: "dynr",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "dynr",
                        domProps: { value: _vm.dynr },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.dynr = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.bmdy,
                            expression: "bmdy",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "bmdy",
                        attrs: { type: "text" },
                        domProps: { value: _vm.bmdy },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.bmdy = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown08",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown17()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown17,
                          expression: "isShowSetDown17"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/1-16.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.bmdy,
                            expression: "bmdy",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "bmdy",
                        attrs: { type: "text" },
                        domProps: { value: _vm.bmdy },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.bmdy = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "dynr",
                        on: {
                          click: function($event) {
                            return _vm.setDown18()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown18,
                          expression: "isShowSetDown18"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/1-15.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.dynr,
                            expression: "dynr",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "dynr",
                        domProps: { value: _vm.dynr },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.dynr = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.bmdy,
                            expression: "bmdy",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "bmdy",
                        attrs: { type: "text" },
                        domProps: { value: _vm.bmdy },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.bmdy = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown08",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown19()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown19,
                          expression: "isShowSetDown19"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/1-17.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown08",
                        on: {
                          click: function($event) {
                            return _vm.setDown20()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown20,
                          expression: "isShowSetDown20"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/1-18.png")
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown21,
                          expression: "isShowSetDown21"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/2-01.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown10",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown22()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown22,
                          expression: "isShowSetDown22"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/2-02.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown10",
                        on: {
                          click: function($event) {
                            return _vm.setDown23()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown23,
                          expression: "isShowSetDown23"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/2-03.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown11",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown24()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown24,
                          expression: "isShowSetDown24"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/2-04.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown11",
                        on: {
                          click: function($event) {
                            return _vm.setDown25()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown25,
                          expression: "isShowSetDown25"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/2-05.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown12",
                        on: {
                          click: function($event) {
                            return _vm.setDown26()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown26,
                          expression: "isShowSetDown26"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/2-06.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown13",
                        on: {
                          click: function($event) {
                            return _vm.setDown27()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown27,
                          expression: "isShowSetDown27"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/2-07.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown14",
                        on: {
                          click: function($event) {
                            return _vm.setDown28()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown28,
                          expression: "isShowSetDown28"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/2-08.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown15",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown29()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown29,
                          expression: "isShowSetDown29"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/2-09.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown15",
                        on: {
                          click: function($event) {
                            return _vm.setDown30()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown30,
                          expression: "isShowSetDown30"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/2-10.png")
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown31,
                          expression: "isShowSetDown31"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/3-01.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown16",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown32()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown32,
                          expression: "isShowSetDown32"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/3-02.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown16",
                        on: {
                          click: function($event) {
                            return _vm.setDown33()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown33,
                          expression: "isShowSetDown33"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/3-03.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown17",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown34()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isShowSetDown34
                    ? _c("div", { staticClass: "szbox" }, [
                        _c("img", {
                          staticClass: "szbg",
                          attrs: {
                            src: require("../../../../static/feige/3/3-04.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "btn-file",
                          attrs: { type: "file" },
                          on: {
                            change: function($event) {
                              return _vm.tirggerFile($event)
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown35,
                          expression: "isShowSetDown35"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/3-05.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown18",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown36()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown36,
                          expression: "isShowSetDown36"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/3-06.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown18",
                        on: {
                          click: function($event) {
                            return _vm.setDown37()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown37,
                          expression: "isShowSetDown37"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/3-07.png")
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown38,
                          expression: "isShowSetDown38"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/4-001.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown19",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown39()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown39,
                          expression: "isShowSetDown39"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/4-02.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown19",
                        on: {
                          click: function($event) {
                            return _vm.setDown40()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown40,
                          expression: "isShowSetDown40"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/4-03.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown20",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown41()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown41,
                          expression: "isShowSetDown41"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/4-04.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown20",
                        on: {
                          click: function($event) {
                            return _vm.setDown42()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown42,
                          expression: "isShowSetDown42"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/4-05.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "focus",
                            rawName: "v-focus",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticClass: "kjdy03input",
                        attrs: { type: "text" },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.setDown43()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown21",
                        on: {
                          click: function($event) {
                            return _vm.setDown43()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown43,
                          expression: "isShowSetDown43"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/4-06.png")
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown431,
                          expression: "isShowSetDown431"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/4-03.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.duanyuInputVal,
                            expression: "duanyuInputVal",
                            modifiers: { trim: true }
                          },
                          {
                            name: "focus",
                            rawName: "v-focus",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticClass: "input03",
                        domProps: { value: _vm.duanyuInputVal },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.duanyuInputVal = $event.target.value.trim()
                            },
                            _vm.duanyuInput
                          ],
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown432,
                          expression: "isShowSetDown432"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/4-05.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "focus",
                            rawName: "v-focus",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticClass: "kjdy03input",
                        attrs: { type: "text" },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.setDown432()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown21",
                        on: {
                          click: function($event) {
                            return _vm.setDown432()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown433,
                          expression: "isShowSetDown433"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/4-06.png")
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown434,
                          expression: "isShowSetDown434"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/4-03.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.duanyuInputVal1,
                            expression: "duanyuInputVal1",
                            modifiers: { trim: true }
                          },
                          {
                            name: "focus",
                            rawName: "v-focus",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticClass: "input03",
                        domProps: { value: _vm.duanyuInputVal1 },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.duanyuInputVal1 = $event.target.value.trim()
                            },
                            _vm.duanyuInput1
                          ],
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown44,
                          expression: "isShowSetDown44"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/4-07.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown22",
                        on: {
                          mouseenter: function($event) {
                            return _vm.setDown45()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown45,
                          expression: "isShowSetDown45"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/4-08.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown22",
                        on: {
                          click: function($event) {
                            return _vm.setDown46()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown451,
                          expression: "isShowSetDown451"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/4-05.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "focus",
                            rawName: "v-focus",
                            value: true,
                            expression: "true"
                          }
                        ],
                        staticClass: "kjdy03input",
                        attrs: { type: "text" },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.setDown461()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "setdown21",
                        on: {
                          click: function($event) {
                            return _vm.setDown461()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSetDown452,
                          expression: "isShowSetDown452"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/3/4-06.png")
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _c("h3", [
                      _c("span", { staticClass: "line" }),
                      _vm._v(
                        "\n                            提示\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.isShowSetDown ||
                    _vm.isShowSetDown1 ||
                    _vm.isShowSetDown2 ||
                    _vm.isShowSetDown3
                      ? _c("p", [
                          _vm._v("请从"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("客服管理")
                          ]),
                          _vm._v("进入"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("客服工具")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown4 || _vm.isShowSetDown5
                      ? _c("p", [
                          _vm._v("选择客服工具中的"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("快捷短语")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown6 || _vm.isShowSetDown7
                      ? _c("p", [
                          _vm._v("点击"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("新建短语")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown8 ||
                    _vm.isShowSetDown9 ||
                    _vm.isShowSetDown10 ||
                    _vm.isShowSetDown11
                      ? _c("p", [
                          _vm._v("请"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("新增")
                          ]),
                          _vm._v("一个"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("催单")
                          ]),
                          _vm._v("组")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown12 || _vm.isShowSetDown13
                      ? _c("p", [
                          _vm._v("选择"),
                          _c("span", { staticClass: "blod-span" }, [
                            _vm._v("催单")
                          ]),
                          _vm._v("组")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown14 ||
                    _vm.isShowSetDown15 ||
                    _vm.isShowSetDown16 ||
                    _vm.isShowSetDown17 ||
                    _vm.isShowSetDown17 ||
                    _vm.isShowSetDown18 ||
                    _vm.isShowSetDown19
                      ? [
                          _c("p", [
                            _vm._v("添加催单短语内容："),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("亲亲，喜欢的话就下单吧，早拍早发货哦！")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("编码短语设置为："),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("催单")
                            ]),
                            _vm._v("点击"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("确定")
                            ]),
                            _vm._v("按钮进行保存")
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown20 ||
                    _vm.isShowSetDown21 ||
                    _vm.isShowSetDown22
                      ? [
                          _c("p", [
                            _vm._v("请点击"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("模板库导入")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown23 ||
                    _vm.isShowSetDown24 ||
                    _vm.isShowSetDown25 ||
                    _vm.isShowSetDown26 ||
                    _vm.isShowSetDown27 ||
                    _vm.isShowSetDown28 ||
                    _vm.isShowSetDown29
                      ? [
                          _c("p", [
                            _vm._v("请将"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("分组")
                            ]),
                            _vm._v("设置为"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("问候语")
                            ]),
                            _vm._v("，并选择"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("前面2条")
                            ]),
                            _vm._v("快捷问候语；")
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("点击"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("确定导入")
                            ]),
                            _vm._v("按钮")
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown30 ||
                    _vm.isShowSetDown31 ||
                    _vm.isShowSetDown32 ||
                    _vm.isShowSetDown33 ||
                    _vm.isShowSetDown34 ||
                    _vm.isShowSetDown35 ||
                    _vm.isShowSetDown36
                      ? [
                          _c("p", [
                            _vm._v("1.先"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("下载下方的飞鸽快捷短语")
                            ]),
                            _vm._v("表格；")
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("2.点击"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("批量导入")
                            ]),
                            _vm._v("按钮；")
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("3.点击"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("添加文件")
                            ]),
                            _vm._v(
                              "，选择下载的飞鸽快捷短语表格（可以先将下载的表格另存到桌面上，方便导入时快速找到表格）；"
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("4.点击"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("导入")
                            ]),
                            _vm._v("按钮；")
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c("a", { on: { click: _vm.downloadKjdyFile } }, [
                              _vm._v("点击下载“飞鸽快捷短语.csv”")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown37 ||
                    _vm.isShowSetDown38 ||
                    _vm.isShowSetDown39
                      ? [
                          _c("p", [
                            _vm._v("点击右侧的"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("快捷短语；")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown40 ||
                    _vm.isShowSetDown41 ||
                    _vm.isShowSetDown42
                      ? [
                          _c("p", [
                            _vm._v("请采用"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("鼠标左键")
                            ]),
                            _vm._v(
                              "点击快捷短语的方式，给当前用户发送欢迎语："
                            ),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v(
                                "您好，欢迎光临本店，请问有什么可以帮到您？"
                              )
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown43 ||
                    _vm.isShowSetDown431 ||
                    _vm.isShowSetDown432 ||
                    _vm.isShowSetDown433
                      ? [
                          _c("p", [
                            _vm._v("请采用输入"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("/您好")
                            ]),
                            _vm._v("的方式，给当前用户发送欢迎语："),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v(
                                "您好，欢迎光临本店，请问有什么可以帮到您？"
                              )
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSetDown434 ||
                    _vm.isShowSetDown44 ||
                    _vm.isShowSetDown45 ||
                    _vm.isShowSetDown451 ||
                    _vm.isShowSetDown452
                      ? [
                          _c("p", [
                            _vm._v("请采用输入文本"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("您好")
                            ]),
                            _vm._v("的方式，给当前用户发送欢迎语："),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v(
                                "您好，欢迎光临本店，请问有什么可以帮到您？"
                              )
                            ])
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyThird }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-four")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v(
                    "\n                        查看学习资料\n                    "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: require("../../../../static/newqianniu/ppt.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("基础设置（下）.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt2
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt2(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt2 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer2" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "four" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("3、会话窗口")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-four" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "four",
                      src:
                        "http://res.study.itaojin.cn/2023-02/b1da8c11184d4b1da68389bc7e89f0f8.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        您的浏览器不支持 video 标签。\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-four" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSession,
                          expression: "isShowSession"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/4/1.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "four01",
                        on: {
                          mouseenter: function($event) {
                            return _vm.four()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSession1,
                          expression: "isShowSession1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/4/2.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "four01",
                        on: {
                          click: function($event) {
                            return _vm.four1()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSession2,
                          expression: "isShowSession2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/4/3.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "four02",
                        on: {
                          mouseenter: function($event) {
                            return _vm.four2()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSession3,
                          expression: "isShowSession3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/4/4.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "four02",
                        on: {
                          click: function($event) {
                            return _vm.four3()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSession4,
                          expression: "isShowSession4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/4/5.png")
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _c("h3", [
                      _c("span", { staticClass: "line" }),
                      _vm._v(
                        "\n                            提示\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.isShowSession ||
                    _vm.isShowSession1 ||
                    _vm.isShowSession2 ||
                    _vm.isShowSession3 ||
                    _vm.isShowSession4
                      ? [
                          _c("p", [
                            _vm._v("请将当前用户"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("转接")
                            ]),
                            _vm._v("给"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("军瑞")
                            ])
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyFour }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-five")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v(
                    "\n                        查看学习资料\n                    "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: require("../../../../static/newqianniu/ppt.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("会话窗口.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt3
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt3(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt3 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer3" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "five" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("4、商品插件")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-five" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "five",
                      src:
                        "http://res.study.itaojin.cn/2023-02/09572dc3445b4b06871354236e70b454.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        您的浏览器不支持 video 标签。\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-five" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive,
                          expression: "isShowFive"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/5/1.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five01",
                        on: {
                          mouseenter: function($event) {
                            return _vm.five()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive1,
                          expression: "isShowFive1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/5/2.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five01",
                        on: {
                          click: function($event) {
                            return _vm.five1()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive2,
                          expression: "isShowFive2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/5/3.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five02",
                        on: {
                          mouseenter: function($event) {
                            return _vm.five2()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive3,
                          expression: "isShowFive3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/5/4.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five02",
                        on: {
                          click: function($event) {
                            return _vm.five3()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive4,
                          expression: "isShowFive4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/5/5.png")
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive5,
                          expression: "isShowFive5"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/5/6.1.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five03",
                        on: {
                          mouseenter: function($event) {
                            return _vm.five5()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive6,
                          expression: "isShowFive6"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/5/6.2.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five03",
                        on: {
                          click: function($event) {
                            return _vm.five6()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive7,
                          expression: "isShowFive7"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/5/7.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five04",
                        on: {
                          mouseenter: function($event) {
                            return _vm.five7()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive8,
                          expression: "isShowFive8"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/5/8.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "five04",
                        on: {
                          click: function($event) {
                            return _vm.five8()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowFive9,
                          expression: "isShowFive9"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/5/9.png")
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _c("h3", [
                      _c("span", { staticClass: "line" }),
                      _vm._v(
                        "\n                            提示\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.isShowFive ||
                    _vm.isShowFive1 ||
                    _vm.isShowFive2 ||
                    _vm.isShowFive3 ||
                    _vm.isShowFive4
                      ? [
                          _c("p", [
                            _vm._v("请点击商品插件，将"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("全部商品")
                            ]),
                            _vm._v("中"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("销量最高")
                            ]),
                            _vm._v("的"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("腰带")
                            ]),
                            _vm._v("链接发送给用户")
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowFive5 ||
                    _vm.isShowFive6 ||
                    _vm.isShowFive7 ||
                    _vm.isShowFive8 ||
                    _vm.isShowFive9
                      ? [
                          _c("p", [
                            _vm._v("请将"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("浏览足迹")
                            ]),
                            _vm._v("中"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("销量最高")
                            ]),
                            _vm._v("的"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("腰带")
                            ]),
                            _vm._v("链接发送给用户")
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyFive }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-six")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v(
                    "\n                        查看学习资料\n                    "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: require("../../../../static/newqianniu/ppt.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("商品插件.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt4
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt4(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt4 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer4" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "six" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("5、订单插件")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-six" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "six",
                      src:
                        "http://res.study.itaojin.cn/2023-02/b2b06910e7194460875ed8c6ed04e312.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        您的浏览器不支持 video 标签。\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-six" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix,
                          expression: "isShowSix"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/6/1-1.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six01",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix1,
                          expression: "isShowSix1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/6/1-2.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six01",
                        on: {
                          click: function($event) {
                            return _vm.six1()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix2,
                          expression: "isShowSix2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/6/1-3.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.beizhu,
                            expression: "beizhu",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "beizhu",
                        domProps: { value: _vm.beizhu },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.beizhu = $event.target.value.trim()
                            },
                            _vm.beiZhuInput
                          ],
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six03",
                        on: {
                          click: function($event) {
                            return _vm.six121()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six033",
                        on: {
                          click: function($event) {
                            return _vm.six122()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix3,
                          expression: "isShowSix3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/6/1-4.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six03",
                        on: {
                          click: function($event) {
                            return _vm.six121()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six02",
                        on: {
                          click: function($event) {
                            return _vm.six3()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix4,
                          expression: "isShowSix4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/6/1-5.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six03",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six4()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix5,
                          expression: "isShowSix5"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/6/1-6.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six03",
                        on: {
                          click: function($event) {
                            return _vm.six5()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix6,
                          expression: "isShowSix6"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/6/1-7.png")
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix7,
                          expression: "isShowSix7"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/6/2-11.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six04",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six6()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix8,
                          expression: "isShowSix8"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/6/2-12.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six04",
                        on: {
                          click: function($event) {
                            return _vm.six7()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix9,
                          expression: "isShowSix9"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/6/2-2.png")
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix10,
                          expression: "isShowSix10"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/6/3-1.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six05",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six8()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix11,
                          expression: "isShowSix11"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/6/3-2.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six05",
                        on: {
                          click: function($event) {
                            return _vm.six9()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix12,
                          expression: "isShowSix12"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/6/3-3.png")
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix13,
                          expression: "isShowSix13"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/6/4-1.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six06",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six10()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix14,
                          expression: "isShowSix14"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/6/4-2.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six06",
                        on: {
                          click: function($event) {
                            return _vm.six11()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix15,
                          expression: "isShowSix15"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/6/4-3.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.yjgj,
                            expression: "yjgj",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "yjgj",
                        attrs: { type: "text" },
                        domProps: { value: _vm.yjgj },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.yjgj = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.yfInput,
                            expression: "yfInput",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "yfInput",
                        attrs: { type: "text" },
                        domProps: { value: _vm.yfInput },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.yfInput = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six07",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six12()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix16,
                          expression: "isShowSix16"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/6/4-4.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six07",
                        on: {
                          click: function($event) {
                            return _vm.six13()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix17,
                          expression: "isShowSix17"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/6/4-5.png")
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix18,
                          expression: "isShowSix18"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/6/5-2.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six08",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six14()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix19,
                          expression: "isShowSix19"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/6/5-3.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six08",
                        on: {
                          click: function($event) {
                            return _vm.six15()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix20,
                          expression: "isShowSix20"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/6/5-4.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six081",
                        on: {
                          click: function($event) {
                            return _vm.six16()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix21,
                          expression: "isShowSix21"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/6/5-5.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.sjhm,
                            expression: "sjhm",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "sjhm",
                        attrs: { type: "text" },
                        domProps: { value: _vm.sjhm },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.sjhm = $event.target.value.trim()
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six09",
                        on: {
                          mouseenter: function($event) {
                            return _vm.six17()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix22,
                          expression: "isShowSix22"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/6/5-6.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "six09",
                        on: {
                          click: function($event) {
                            return _vm.six18()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSix23,
                          expression: "isShowSix23"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/6/5-7.png")
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _c("h3", [
                      _c("span", { staticClass: "line" }),
                      _vm._v(
                        "\n                            提示\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.isShowSix ||
                    _vm.isShowSix1 ||
                    _vm.isShowSix2 ||
                    _vm.isShowSix3 ||
                    _vm.isShowSix4 ||
                    _vm.isShowSix5 ||
                    _vm.isShowSix6
                      ? [
                          _c("p", [
                            _vm._v("假设此商家规定"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("红色彩旗跟发货相关")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("请给该用户添加"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("备注")
                            ]),
                            _vm._v("内容："),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("用户要求发顺丰")
                            ]),
                            _vm._v("并"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("选择对应的彩旗")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSix7 || _vm.isShowSix8 || _vm.isShowSix9
                      ? [
                          _c("p", [
                            _vm._v("请给用户发送"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("核对地址")
                            ]),
                            _vm._v("卡片")
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSix10 || _vm.isShowSix11 || _vm.isShowSix12
                      ? [
                          _c("p", [
                            _vm._v("请给用户发送订单"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("催付")
                            ]),
                            _vm._v("卡片")
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSix13 ||
                    _vm.isShowSix14 ||
                    _vm.isShowSix15 ||
                    _vm.isShowSix16 ||
                    _vm.isShowSix17
                      ? [
                          _c("p", [
                            _vm._v("请采用"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("一键改价")
                            ]),
                            _vm._v("方式，将"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("最终实付价")
                            ]),
                            _vm._v("改为"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("48")
                            ]),
                            _vm._v("元，"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("运费")
                            ]),
                            _vm._v("改为"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("10")
                            ]),
                            _vm._v("元")
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSix18 ||
                    _vm.isShowSix19 ||
                    _vm.isShowSix20 ||
                    _vm.isShowSix21 ||
                    _vm.isShowSix22 ||
                    _vm.isShowSix23
                      ? [
                          _c("p", [
                            _vm._v("请在"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("改地址")
                            ]),
                            _vm._v("中，将用户的"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("手机号码")
                            ]),
                            _vm._v("改成"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("13512345678")
                            ])
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudySix }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-seven")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v(
                    "\n                        查看学习资料\n                    "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: require("../../../../static/newqianniu/ppt.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("订单插件.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt5
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt5(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt5 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer5" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "seven" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("6、退出飞鸽")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-seven" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "seven",
                      src:
                        "http://res.study.itaojin.cn/2023-02/bb58cf754fc24605ac2e993b864565ce.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        您的浏览器不支持 video 标签。\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-seven" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven,
                          expression: "isShowSeven"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/7/1.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven01",
                        on: {
                          click: function($event) {
                            return _vm.seven()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven1,
                          expression: "isShowSeven1"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/7/2.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven02",
                        on: {
                          mouseenter: function($event) {
                            return _vm.seven1()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven2,
                          expression: "isShowSeven2"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/7/3.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven02",
                        on: {
                          click: function($event) {
                            return _vm.seven2()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven3,
                          expression: "isShowSeven3"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/7/4.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven01",
                        on: {
                          click: function($event) {
                            return _vm.seven3()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven4,
                          expression: "isShowSeven4"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/7/5.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven03",
                        on: {
                          click: function($event) {
                            return _vm.seven4()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven5,
                          expression: "isShowSeven5"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/7/6.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven04",
                        on: {
                          mouseenter: function($event) {
                            return _vm.seven5()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven6,
                          expression: "isShowSeven6"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/7/7.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven04",
                        on: {
                          click: function($event) {
                            return _vm.seven6()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven7,
                          expression: "isShowSeven7"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/7/8.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven05",
                        on: {
                          mouseenter: function($event) {
                            return _vm.seven7()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven8,
                          expression: "isShowSeven8"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/7/9.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven05",
                        on: {
                          click: function($event) {
                            return _vm.seven8()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven9,
                          expression: "isShowSeven9"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/7/10.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "seven06",
                        on: {
                          mouseenter: function($event) {
                            return _vm.seven9()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven10,
                          expression: "isShowSeven10"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/7/11.png")
                        }
                      }),
                      _vm._v(" "),
                      _vm.isShowSmallPic
                        ? _c("img", {
                            staticClass: "small-img",
                            attrs: {
                              src: require("../../../../static/feige/7/12.png")
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isShowSmallPic
                        ? _c("div", {
                            staticClass: "seven06",
                            on: {
                              contextmenu: function($event) {
                                $event.preventDefault()
                                return _vm.seven10()
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isShowSmallPic
                        ? _c("div", {
                            staticClass: "seven07",
                            on: {
                              click: function($event) {
                                return _vm.seven11()
                              }
                            }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowSeven11,
                          expression: "isShowSeven11"
                        }
                      ],
                      staticClass: "szbox"
                    },
                    [
                      _c("img", {
                        staticClass: "szbg",
                        attrs: {
                          src: require("../../../../static/feige/7/13.png")
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _c("h3", [
                      _c("span", { staticClass: "line" }),
                      _vm._v(
                        "\n                            提示\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.isShowSeven || _vm.isShowSeven1 || _vm.isShowSeven2
                      ? [
                          _c("p", [
                            _vm._v("请将状态切换为："),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("小休")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSeven3 || _vm.isShowSeven4
                      ? [
                          _c("p", [
                            _vm._v("请将状态切换为："),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("离线")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSeven5 || _vm.isShowSeven6
                      ? [
                          _c("p", [
                            _vm._v("请关闭"),
                            _c("span", { staticClass: "blod-span" }, [
                              _vm._v("接待页面")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSeven7 || _vm.isShowSeven8
                      ? [_c("p", [_vm._v("请点击右下方显示隐藏的图标")])]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowSeven9 || _vm.isShowSeven10 || _vm.isShowSeven11
                      ? [_c("p", [_vm._v("右键点击飞鸽小图标")])]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-seven" } },
                  [
                    _c("div", { staticClass: "tip" }, [
                      _c("span", { staticClass: "el-icon-success" }),
                      _vm._v(" "),
                      _c("p", [_vm._v("实操通关，进入下一关吧")]),
                      _vm._v(" "),
                      _c("p", [
                        _c(
                          "a",
                          {
                            staticClass: "restart",
                            on: { click: _vm.restartStudySeven }
                          },
                          [
                            _c("i", { staticClass: "el-icon-refresh-left" }),
                            _vm._v("重练")
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "startstudy",
                            on: {
                              click: function($event) {
                                return _vm.studyNext("#tab-eight")
                              }
                            }
                          },
                          [_vm._v("GO，下一关")]
                        )
                      ])
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v(
                    "\n                        查看学习资料\n                    "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: require("../../../../static/newqianniu/ppt.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("退出飞鸽.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt6
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt6(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt6 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer6" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "eight" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("7、从多脉启动抖店")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-eight" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "eight",
                      src:
                        "https://res.study.itaojin.cn/training-resource/2025-09/20250908.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n                        您的浏览器不支持 video 标签。\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "video-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-eight" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-eight" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "szbox" }, [
                    _c("div", { staticClass: "duomai-box" }, [
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.duomaiStep == 1 && !_vm.mouseFocusDM,
                            expression: "duomaiStep == 1 && !mouseFocusDM"
                          }
                        ],
                        staticClass: "szbg",
                        attrs: {
                          src: require("@/assets/images/jingmai/duom011.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.duomaiStep == 1 && _vm.mouseFocusDM,
                            expression: "duomaiStep == 1 && mouseFocusDM"
                          }
                        ],
                        staticClass: "szbg",
                        attrs: {
                          src: require("@/assets/images/jingmai/duom022.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.duomaiStep == 1,
                            expression: "duomaiStep == 1"
                          }
                        ],
                        staticClass: "desktop-hover",
                        on: {
                          click: function() {
                            _vm.duomaiStep = 2
                            _vm.mouseFocusDM = false
                          },
                          mouseenter: function($event) {
                            _vm.mouseFocusDM = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusDM = false
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.duomaiStep == 2 && !_vm.mouseFocusDM,
                            expression: "duomaiStep == 2 && !mouseFocusDM"
                          }
                        ],
                        staticClass: "szbg",
                        attrs: {
                          src: require("@/assets/images/jingmai/duom033.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.duomaiStep == 2 && _vm.mouseFocusDM,
                            expression: "duomaiStep == 2 && mouseFocusDM"
                          }
                        ],
                        staticClass: "szbg",
                        attrs: {
                          src: require("@/assets/images/jingmai/duom044.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.duomaiStep == 2,
                            expression: "duomaiStep == 2"
                          }
                        ],
                        staticClass: "doudian-hover",
                        on: {
                          click: function() {
                            _vm.duomaiStep = 3
                            _vm.mouseFocusDM = false
                          },
                          mouseenter: function($event) {
                            _vm.mouseFocusDM = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusDM = false
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.duomaiStep == 3 && !_vm.mouseFocusDM,
                            expression: "duomaiStep == 3 && !mouseFocusDM"
                          }
                        ],
                        staticClass: "szbg",
                        attrs: {
                          src: require("@/assets/images/jingmai/duom055.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.duomaiStep == 3,
                            expression: "duomaiStep == 3"
                          }
                        ],
                        staticClass: "msg-hover",
                        on: { click: _vm.lastStep }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.duomaiStep == 4,
                            expression: "duomaiStep == 4"
                          }
                        ],
                        staticClass: "szbg",
                        attrs: {
                          src: require("@/assets/images/jingmai/duom066.png"),
                          alt: ""
                        }
                      })
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v(
                      "\n                            提示\n                        "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.duomaiStep == 1
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("打开左侧")
                          ]),
                          _vm._v("练习场中的"),
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("多脉客服助手")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.duomaiStep == 2
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("启动抖店")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.duomaiStep == 3
                    ? _c(
                        "p",
                        [
                          _c("font", { attrs: { color: "red" } }, [
                            _vm._v("点击右上角的前往飞鸽IM图标，进入接待中心")
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-eight" } },
                  [
                    _c(
                      "div",
                      { staticClass: "tip", staticStyle: { width: "290px" } },
                      [
                        _c("span", { staticClass: "el-icon-success" }),
                        _vm._v(" "),
                        _vm.examNum
                          ? _c(
                              "div",
                              { staticStyle: { "margin-top": "5px" } },
                              [
                                _vm._v(
                                  "\n                            你已完成\n                            "
                                ),
                                _c("b", { staticStyle: { color: "#66B1FF" } }, [
                                  _vm._v(_vm._s(_vm.myExamNum))
                                ]),
                                _vm._v(
                                  "\n                            次，需完成\n                            "
                                ),
                                _c("b", { staticStyle: { color: "#66B1FF" } }, [
                                  _vm._v(_vm._s(_vm.examNum))
                                ]),
                                _vm._v(
                                  "\n                            次\n                        "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.examNum || _vm.myExamNum >= _vm.examNum
                          ? _c(
                              "div",
                              { staticStyle: { "margin-top": "5px" } },
                              [_vm._v("接下来请完成《抖店模拟实操》。")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.examNum || _vm.myExamNum >= _vm.examNum
                          ? _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                staticStyle: {
                                  width: "160px",
                                  "margin-top": "5px"
                                },
                                on: { click: _vm.goExam }
                              },
                              [_vm._v("去完成抖店模拟实操")]
                            )
                          : _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                staticStyle: { width: "160px" },
                                on: { click: _vm.goExam }
                              },
                              [_vm._v("继续学习")]
                            )
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v(
                    "\n                        查看学习资料\n                    "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: require("../../../../static/newqianniu/ppt.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("抖店练习-从多脉启动抖店.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt7
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt7(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt7 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer7" } })
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d65b6d7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d65b6d7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/FBT/doudian.vue
// module id = 1734
// module chunks = 0